import {
  IPositionType,
  TPositionType
} from "../../../model/position/PositionType";
import { SourceDataConstants } from "../../../common/Constants";

export interface TPositionTypePresentationModel extends TPositionType {
  editable: boolean;
}

const PositionTypePresentationModel = (
  data: IPositionType
): TPositionTypePresentationModel => {
  return {
    ...data,
    editable: data.dataSource === SourceDataConstants.OPERATOR ? true : false
  };
};

export default PositionTypePresentationModel;
